import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=18c80ace&scoped=true&"
import script from "./Leave.vue?vue&type=script&lang=js&"
export * from "./Leave.vue?vue&type=script&lang=js&"
import style0 from "./Leave.vue?vue&type=style&index=0&id=18c80ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c80ace",
  null
  
)

export default component.exports